import type { Offering } from '@/types'

export const offerings: Offering[] = [
    {
        title: ['Few, But', 'Flawless'],
        body: 'We ship one section at a time, and only when it’s undeniable — no filler, no volume play. Every scene in the library earned its place, or it never went in.'
    },
    {
        title: ['Stop', 'Scrolling'],
        body: 'The bar is a single question: would you stop scrolling to work out how it was made? Particles, dot grids, fade-ins, gradient text — if an AI could sneeze it out, it doesn’t ship.'
    },
    {
        title: ['It Really', 'Moves'],
        body: 'Every scene runs on real motion — springs, velocity and cursor forces on a live clock, not CSS transitions playing dress-up. It reacts to you, and keeps reacting.'
    },
    {
        title: ['All Of It,', 'Forever'],
        body: 'Built once, kept for good. Drop it into any page, restyle the palette, rewrite the copy — it’s yours to reshape and reuse however the work demands, for as long as you need it.'
    }
]
